export enum OrderType {
  'Draft', 'In progress', 'Ordered', 'Completed', 'Canceled'
};

export type OrdersItemDto = {
  id: string;
  type: OrderType;
  text?: string;
  dateOn: Date;
  dateIn?: Date;
  dateOut?: Date;
  value: number;
};

export type OrdersListDto = OrdersItemDto[];

export type OrderItemDto = {
  id: string,
  timestamp: Date,
  apartment: number,
  services: string,
  total: number,
  status: string
};

export enum PaymentMethod {
  CreditCard, Balance
}

export enum PaymentStatus {
  Pending = 0,
  Paid = 1,
  Failed = 2,
}

export enum OrderStatus {
  Draft,
  PendingPayment,
  InProgress,
  Ordered,
  Completed,
  Canceled,
  Rejected,
  PendingConfirmation
};


export type OrderListItemResponseDto = {
  id: string;
  documentDate: Date;
  authorName?: string;
  apartmentName?: string;
  services?: string;
  totalAmount: number;
  status: OrderStatus;
};

export type OrderListItemResponseDtoListResponseDto = {
  items?: OrderListItemResponseDto[];
  totalCount: number;
};

export type OrderLineDto = {
  id: string;
  price: number;
  quantity: number;
  amount: number;
  orderItemId: string;
  orderItemName?: string;
};

export type CreateUpdateOrderLineDto = {
  orderItemId: string;
  quantity: number;
  price: number;
};

export type OrderDetailsResponseDto = {
  id: string;
  apartmentId: string;
  apartmentName?: string;
  deliveryDate: Date;
  paymentMethod: PaymentMethod;
  serviceId: string;
  serviceName?: string;
  documentDate: Date;
  status: OrderStatus;
  authorId: string;
  authorName?: string;
  totalAmount: number;
  lines?: OrderLineDto[];
  paymentStatus?: PaymentStatus | null;
  paymentErrorMessage?: string | null;
  canRetryPayment?: boolean;
};

export type CreateOrderRequestDto = {
  isDraft: boolean;
  apartmentId: string;
  deliveryDate: Date;
  paymentMethod?: PaymentMethod;
  serviceId: string;
  lines?: CreateUpdateOrderLineDto[];
};

export type CreateOrderResponseDto = {
  id: string;
  redirectUrl?: string;
};

export type UpdateOrderResponseDto = {
  redirectUrl?: string;
};

export type UpdateOrderRequestDto = {
  isDraft: boolean;
  apartmentId: string;
  deliveryDate: Date;
  paymentMethod?: PaymentMethod;
  serviceId: string;
  lines?: CreateUpdateOrderLineDto[];
};

export type GetOrderServicesListItem = {
  id:	string;
  name?: string;
  description?: string | null;
  price?: number;
};

export type GetOrderServicesList = {
  items?: GetOrderServicesListItem[];
  totalCount: number;
};

export type GetOrderItemsListItem = {
  id:	string;
  name?: string;
  price: number;
  imageUrl?: string;
};

export type GetOrderItemsList = {
  items?: GetOrderItemsListItem[];
  totalCount: number;
};

export type GetOrderApartmentsLookupListItem = {
  id:	string;
  name?: string;
};

export type GetOrderApartmentsLookupList = {
  items?: GetOrderApartmentsLookupListItem[];
  totalCount: number;
};

export type GetOrderAuthorsLookupListItem = {
  id:	string;
  name?: string;
};

export type GetOrderAuthorsLookupList = {
  items?: GetOrderAuthorsLookupListItem[];
  totalCount: number;
};

export type GetOrderServicesLookupListItem = {
  id:	string;
  name?: string;
  description?: string | null;
  price?: number;
};

export type GetOrderServicesLookupList = {
  items?: GetOrderServicesLookupListItem[];
  totalCount: number;
};